import { TextInput, BooleanInput } from 'react-admin';

export const Filters = [
    <TextInput label="Busca por nome" source="client_name" alwaysOn variant="standard" />,    
    <TextInput label="WP ID" source="wp_id" variant="standard" />,
    // <TextInput label="ID" source="id" variant="standard" />,
    <TextInput label="Tipo de métricas" source="ga_metrics_type" variant="standard" />,
    <BooleanInput label="Ativo" source="active" variant="standard" alwaysOn />,
];